// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsVpcsIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-vpcs_svga)" d="M40 0H0v40h40z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M27 21.96c0 1.65-.5 7-7 7-6.66 0-7-5.83-7-7v-8.22l7-2.67 7 2.67zM7 10h3V7H7zm23 0h3V7h-3zm0 23h3v-3h-3zM7 33h3v-3H7zm26.5-22a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v3.8l-2.27 2.26-6.55-2.5a.5.5 0 0 0-.36 0l-6.55 2.5L11 10.3V6.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h3.8l1.96 1.97a.5.5 0 0 0-.26.42v8.57c0 1.43.32 2.95 1.05 4.28L10.29 29H6.5a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-3.8l2.6-2.6c1.25 1.67 3.3 2.86 6.4 2.86 3.34 0 5.29-1.28 6.42-2.83L29 29.71v3.79c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-3.8l-2.74-2.75A10 10 0 0 0 28 21.96V13.4q-.01-.28-.26-.42L29.7 11zM24 21.96c0 2.52-1.16 3.8-3.5 3.97V14.47L24 15.8zm-8 0V15.8l3.5-1.33v11.46q-3.48-.25-3.5-3.97m3.82-8.68-4.5 1.71a.5.5 0 0 0-.32.47v6.5c0 3.23 1.77 5 5 5 3.27 0 5-1.73 5-5v-6.5a.5.5 0 0 0-.32-.47l-4.5-1.71a.5.5 0 0 0-.36 0"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="aws-vpcs_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsVpcs",
);
export default AwsVpcsIcon;
